import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tm-root" }
const _hoisted_2 = { class: "tm-toolbar" }
const _hoisted_3 = { class: "tm-title-wrap" }
const _hoisted_4 = { class: "tm-count" }
const _hoisted_5 = {
  key: 0,
  class: "tm-toolbar-actions"
}
const _hoisted_6 = {
  key: 0,
  class: "tm-panel"
}
const _hoisted_7 = { class: "tm-panel-inner" }
const _hoisted_8 = { class: "tm-panel-header" }
const _hoisted_9 = { class: "tm-form-row" }
const _hoisted_10 = { class: "tm-field" }
const _hoisted_11 = { class: "tm-switch" }
const _hoisted_12 = { class: "tm-field" }
const _hoisted_13 = {
  key: 0,
  class: "tm-user-list"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "tm-user-name" }
const _hoisted_16 = { class: "tm-user-meta" }
const _hoisted_17 = {
  key: 0,
  class: "tm-members-block"
}
const _hoisted_18 = { class: "tm-member-tags" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "tm-panel-footer" }
const _hoisted_21 = {
  key: 1,
  class: "tm-error"
}
const _hoisted_22 = {
  key: 0,
  class: "tm-empty"
}
const _hoisted_23 = {
  key: 1,
  class: "tm-grid"
}
const _hoisted_24 = { class: "tm-card-header" }
const _hoisted_25 = { class: "tm-card-title-wrap" }
const _hoisted_26 = { class: "tm-card-title" }
const _hoisted_27 = { class: "tm-card-sub" }
const _hoisted_28 = { class: "tm-card-top-actions" }
const _hoisted_29 = {
  key: 0,
  class: "tm-card-hover"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 0,
  class: "tm-empty-members"
}
const _hoisted_33 = {
  key: 1,
  class: "tm-member-cloud"
}
const _hoisted_34 = { class: "tm-modal" }
const _hoisted_35 = { class: "tm-panel-header" }
const _hoisted_36 = { class: "tm-form-row" }
const _hoisted_37 = { class: "tm-field" }
const _hoisted_38 = { class: "tm-switch" }
const _hoisted_39 = { class: "tm-field" }
const _hoisted_40 = {
  key: 0,
  class: "tm-user-list"
}
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "tm-user-name" }
const _hoisted_43 = { class: "tm-user-meta" }
const _hoisted_44 = {
  key: 0,
  class: "tm-members-block"
}
const _hoisted_45 = { class: "tm-member-tags" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "tm-panel-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "tm-title" }, "Equipes", -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.teams.length) + " equipe" + _toDisplayString(_ctx.teams.length !== 1 ? 's' : ''), 1)
      ]),
      (_ctx.accessMode === 'edit')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "tm-btn tm-btn-ghost tm-btn-sm",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCreateForm = !_ctx.showCreateForm))
            }, _toDisplayString(_ctx.showCreateForm ? 'Fechar' : '+ Equipe'), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_Transition, { name: "slide-down" }, {
      default: _withCtx(() => [
        (_ctx.showCreateForm && _ctx.accessMode === 'edit')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[16] || (_cache[16] = _createElementVNode("span", { class: "tm-panel-title" }, "Nova equipe", -1)),
                  _createElementVNode("button", {
                    class: "tm-close-btn",
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCreateForm = false))
                  }, "✕")
                ]),
                _createElementVNode("form", {
                  class: "tm-form",
                  onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitCreateTeam && _ctx.submitCreateTeam(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _cache[17] || (_cache[17] = _createElementVNode("label", null, "Nome da equipe", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newTeam.name) = $event)),
                        type: "text",
                        placeholder: "Ex: Montagem Estrutural"
                      }, null, 512), [
                        [_vModelText, _ctx.newTeam.name]
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newTeam.isGlobal) = $event)),
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.newTeam.isGlobal]
                      ]),
                      _cache[18] || (_cache[18] = _createElementVNode("span", null, "Equipe global", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", null, "Adicionar pessoas", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userSearch) = $event)),
                      type: "text",
                      placeholder: "Buscar por nome ou usuário",
                      class: "tm-search"
                    }, null, 512), [
                      [_vModelText, _ctx.userSearch]
                    ]),
                    (_ctx.filteredAvailableUsers.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAvailableUsers, (user) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: user.username,
                              class: "tm-user-option",
                              type: "button",
                              onClick: ($event: any) => (_ctx.addUserToNewTeam(user.username))
                            }, [
                              _createElementVNode("span", _hoisted_15, _toDisplayString(user.name), 1),
                              _createElementVNode("span", _hoisted_16, "@" + _toDisplayString(user.username), 1)
                            ], 8, _hoisted_14))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.newTeam.members.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _cache[20] || (_cache[20] = _createElementVNode("span", { class: "tm-block-label" }, "Membros selecionados", -1)),
                        _createElementVNode("div", _hoisted_18, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newTeam.members, (member) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: member,
                              class: "tm-member-tag"
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.displayUser(member)) + " ", 1),
                              _createElementVNode("button", {
                                type: "button",
                                class: "tm-tag-remove",
                                onClick: _withModifiers(($event: any) => (_ctx.removeUserFromNewTeam(member)), ["prevent"])
                              }, "✕", 8, _hoisted_19)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      class: "tm-btn tm-btn-ghost tm-btn-sm",
                      type: "button",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showCreateForm = false))
                    }, "Cancelar"),
                    _cache[21] || (_cache[21] = _createElementVNode("button", {
                      class: "tm-btn tm-btn-primary tm-btn-sm",
                      type: "submit"
                    }, "Criar equipe", -1))
                  ]),
                  (_ctx.formError)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.formError), 1))
                    : _createCommentVNode("", true)
                ], 32)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.teams.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "tm-empty-icon" }, "👥", -1)),
          _cache[23] || (_cache[23] = _createElementVNode("p", null, "Nenhuma equipe criada.", -1)),
          (_ctx.accessMode === 'edit')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "tm-btn tm-btn-primary tm-btn-sm",
                type: "button",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showCreateForm = true))
              }, " Criar equipe "))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team) => {
            return (_openBlock(), _createElementBlock("article", {
              key: team.id,
              class: "tm-card"
            }, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _cache[24] || (_cache[24] = _createStaticVNode("<div class=\"tm-card-icon\" data-v-70f3d5ea><svg width=\"28\" height=\"22\" viewBox=\"0 0 38 30\" fill=\"none\" data-v-70f3d5ea><rect x=\"0\" y=\"6\" width=\"38\" height=\"24\" rx=\"3\" fill=\"currentColor\" opacity=\"0.25\" data-v-70f3d5ea></rect><rect x=\"0\" y=\"3\" width=\"16\" height=\"6\" rx=\"2\" fill=\"currentColor\" opacity=\"0.4\" data-v-70f3d5ea></rect><rect x=\"0\" y=\"6\" width=\"38\" height=\"24\" rx=\"3\" fill=\"currentColor\" opacity=\"0.15\" data-v-70f3d5ea></rect></svg></div>", 1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_26, _toDisplayString(team.name), 1),
                    _createElementVNode("div", _hoisted_27, _toDisplayString(team.members.length) + " membro" + _toDisplayString(team.members.length !== 1 ? 's' : ''), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["tm-badge", team.isGlobal ? 'tm-badge-global' : 'tm-badge-local'])
                  }, _toDisplayString(team.isGlobal ? 'Global' : 'Local'), 3),
                  (_ctx.accessMode === 'edit')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("button", {
                          class: "tm-action-btn",
                          title: "Editar",
                          type: "button",
                          onClick: ($event: any) => (_ctx.openEditTeam(team))
                        }, [...(_cache[25] || (_cache[25] = [
                          _createElementVNode("svg", {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 16 16",
                            fill: "none"
                          }, [
                            _createElementVNode("path", {
                              d: "M11.5 2.5a1.5 1.5 0 012 2L5 13H3v-2L11.5 2.5z",
                              stroke: "currentColor",
                              "stroke-width": "1.3",
                              fill: "none"
                            })
                          ], -1)
                        ]))], 8, _hoisted_30),
                        _createElementVNode("button", {
                          class: "tm-action-btn tm-action-danger",
                          title: "Excluir",
                          type: "button",
                          onClick: ($event: any) => (_ctx.deleteTeam(team.id))
                        }, [...(_cache[26] || (_cache[26] = [
                          _createElementVNode("svg", {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 16 16",
                            fill: "none"
                          }, [
                            _createElementVNode("path", {
                              d: "M3 4h10M6 4V2h4v2M5 4v9a1 1 0 001 1h4a1 1 0 001-1V4H5z",
                              stroke: "currentColor",
                              "stroke-width": "1.3",
                              fill: "none"
                            })
                          ], -1)
                        ]))], 8, _hoisted_31)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (team.members.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, "Sem membros"))
                : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(team.members, (member) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: member,
                        class: "tm-member-pill"
                      }, _toDisplayString(_ctx.displayUser(member)), 1))
                    }), 128))
                  ]))
            ]))
          }), 128))
        ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "viewer-fade" }, {
        default: _withCtx(() => [
          (_ctx.editingTeam)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "tm-overlay",
                onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.editingTeam = null), ["self"]))
              }, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _cache[27] || (_cache[27] = _createElementVNode("span", { class: "tm-panel-title" }, "Editar equipe", -1)),
                    _createElementVNode("button", {
                      class: "tm-close-btn",
                      type: "button",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.editingTeam = null))
                    }, "✕")
                  ]),
                  _createElementVNode("form", {
                    class: "tm-form",
                    onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitEditTeam && _ctx.submitEditTeam(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _cache[28] || (_cache[28] = _createElementVNode("label", null, "Nome da equipe", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editingTeam.name) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.editingTeam.name]
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_38, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editingTeam.isGlobal) = $event)),
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.editingTeam.isGlobal]
                        ]),
                        _cache[29] || (_cache[29] = _createElementVNode("span", null, "Equipe global", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _cache[30] || (_cache[30] = _createElementVNode("label", null, "Adicionar pessoas", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editUserSearch) = $event)),
                        type: "text",
                        placeholder: "Buscar por nome ou usuário",
                        class: "tm-search"
                      }, null, 512), [
                        [_vModelText, _ctx.editUserSearch]
                      ]),
                      (_ctx.filteredEditUsers.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredEditUsers, (user) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: user.username,
                                class: "tm-user-option",
                                type: "button",
                                onClick: ($event: any) => (_ctx.addUserToEditTeam(user.username))
                              }, [
                                _createElementVNode("span", _hoisted_42, _toDisplayString(user.name), 1),
                                _createElementVNode("span", _hoisted_43, "@" + _toDisplayString(user.username), 1)
                              ], 8, _hoisted_41))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.editingTeam.members.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _cache[31] || (_cache[31] = _createElementVNode("span", { class: "tm-block-label" }, "Membros da equipe", -1)),
                          _createElementVNode("div", _hoisted_45, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editingTeam.members, (member) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: member,
                                class: "tm-member-tag"
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.displayUser(member)) + " ", 1),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "tm-tag-remove",
                                  onClick: _withModifiers(($event: any) => (_ctx.removeUserFromEditTeam(member)), ["prevent"])
                                }, "✕", 8, _hoisted_46)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("button", {
                        class: "tm-btn tm-btn-ghost tm-btn-sm",
                        type: "button",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.editingTeam = null))
                      }, "Cancelar"),
                      _cache[32] || (_cache[32] = _createElementVNode("button", {
                        class: "tm-btn tm-btn-primary tm-btn-sm",
                        type: "submit"
                      }, "Salvar", -1))
                    ])
                  ], 32)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}